import Link from "next/link";
import React from "react";

import { dateFormatter } from "src/utils/helperFunctions";
import { DOCUMENT_URL } from "src/constants/constants";
import defaultImage from "image/image.svg";
import Image from "next/image";
import FeaturedList from "./featuredList";

interface MainSectionProps {
  data: any;
  featuredBlog: any;
}

const MainSection = ({ data, featuredBlog }: MainSectionProps) => {
  const [featureListBlog, setFeatureListBlog] = React.useState(
    featuredBlog || []
  );
  return (
    <div>
      <p className="mb-4 text-lg font-medium md:text-xl dark:text-dark-text-primary">
        {" "}
        Featured{" "}
      </p>
      <div className="grid gap-6 pb-8 border-b md:grid-cols-2">
        <div className="">
          <Link href={`/blog/${data.slug}`}>
            <Image
              width={200}
              height={800}
              className="rounded w-full max-h-[300px] md:h-auto"
              src={
                data?.main_image?.document_name
                  ? `${DOCUMENT_URL}${data.main_image.document_name}`
                  : defaultImage
              }
              alt="blog_image"
            />
          </Link>
          <p className="m-0 mt-2 dark:text-dark-text-primary">
            <Link href={`/blog/${data.slug}`}>{data.title}</Link>
          </p>
          <div className="mt-2 text-xs text-gray-500 dark:text-dark-text-secondary">
            <span className="mr-1 uppercase ">{data.author}</span>|
            <span className="mx-1 uppercase ">{data.minute_read} min read</span>
            |
            <span className="ml-1 uppercase dark:text-dark-text-secondary">
              {dateFormatter(new Date(data.published_date), "d m y")}
            </span>
          </div>
        </div>

        <div>
          <FeaturedList data={featureListBlog} />
        </div>
      </div>
    </div>
  );
};

export default MainSection;
